<template>
    <main ref="tableContainer">
        <section v-if="getLoadingSubject">
            <CarouselLoading v-for="(loading, index) in 4" :key="index" />
        </section>
        <section v-else v-for="(subject ,index) in getSubjects" :key="index" :id="'idSubject_' + subject.id">
            <CarouselVideos :subject="subject" />
        </section>
        <section v-if="getLoadingMoreSubject">
            <CarouselLoading v-for="(loading, index) in 4" :key="index"/>
        </section>
    </main>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { debounce } from 'lodash';
    import CarouselVideos from '@/components/CarouselVideos.vue';
    import CarouselLoading from '@/components/CarouselLoading.vue';
    export default {
        name: 'ListSubjectsComponent',
        components: {
            CarouselVideos,
            CarouselLoading
        },
        data() {
            return {
                busca: "",
                limit_page: 15,
                page: 1
            }
        },
        methods: {
            async handleScroll() {
                // console.log(this.$store.state.subjects.page, ' <  ', this.$store.state.subjects.pages)
                if(this.$store.state.subjects.page < this.$store.state.subjects.pages){
                    await this.$nextTick();
                    const element = this.$refs.tableContainer;
                    // console.log('botton',element.getBoundingClientRect().bottom, '<= height', window.innerHeight + 2)
                    if (element.getBoundingClientRect().bottom <= window.innerHeight + 2) {
                        if(!this.getLoadingSubject && !this.getLoadingMoreSubject){
                            // console.log('Chegou no fim - Carregendo mais ...');
                            this.$store.dispatch('fetchSubjects', { keyword: '', pageNumber: (this.$store.state.subjects.page + 1), sortBy:  this.buttonText});
                        }
                    }
                }
            },
            debouncedSearch: debounce(function() {
                this.page = 1;
                this.carregarSubjects();
            }, 500),
            onSearch() {
                this.debouncedSearch();
            },
        },
        computed:{
            ...mapGetters(['getSubjects', 'getLoadingSubject', 'getLoadingMoreSubject']),
        },
        mounted() {
            window.addEventListener("scroll", this.handleScroll)
        }
    }
</script>